import React from 'react';
import SubscriptionDashboard from '../components/SubscriptionDashboard';

const MySubscription = ({ user, userData }) => {
  return <SubscriptionDashboard user={user} userData={userData} />;
};

export default MySubscription;
